<template>
  <div class="tc-container">
    <ul>
      <li :class="actvIndex == 1 ? 'is-active' : ''" @click="handSelect(1)">
        日
      </li>
      <li :class="actvIndex == 3 ? 'is-active' : ''" @click="handSelect(3)">
        月
      </li>
      <li :class="actvIndex == 4 ? 'is-active' : ''" @click="handSelect(4)">
        年
      </li>
    </ul>
    <div class="tp-chart" ref="myChart"></div>
  </div>
</template>
<script>
  export default {
    props: {},
    data() {
      return {
        actvIndex: 3,
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        let chartDom = this.$refs.myChart
        let myChart = this.$echarts.init(chartDom)
        let option = {
          tooltip: {
            trigger: 'item',
            formatter: '({d}%)',
          },
          color: ['#4CADFF', '#FD5382', '#FFBC47', '#FF7916', '#9C73F8'],
          legend: {
            orient: 'vertical',
            x: 'right',
            data: ['自然灾害', '事故灾害', '公共卫生', '社会安全', '其他事件'],
            textStyle: {
              color: '#fff',
            },
            // formatter: function (name) {
            //   var oa = option.series[0].data
            //   var num = oa[0].value + oa[1].value + oa[2].value + oa[3].value
            //   for (var i = 0; i < option.series[0].data.length; i++) {
            //     if (name == oa[i].name) {
            //       return ((oa[i].value / num) * 100).toFixed(2) + '%'
            //     }
            //   }
            // },
          },
          series: [
            {
              name: '签到比例分析',
              type: 'pie',
              radius: '75%',
              center: ['40%', '50%'],

              data: [
                { value: 335, name: '自然灾害' },
                { value: 310, name: '事故灾害' },
                { value: 234, name: '公共卫生' },
                { value: 135, name: '社会安全' },
                { value: 185, name: '其他事件' },
              ],
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)',
                },
                normal: {
                  label: {
                    show: true,
                    formatter: '{d}%',
                    color: '#fff',
                  },
                },
                labelLine: { show: true },
              },
            },
          ],
        }
        myChart.setOption(option)
        window.addEventListener('resize', () => {
          myChart.resize()
        })
      },
      handSelect(i) {
        this.actvIndex = i
      },
    },
  }
</script>
<style lang="scss" scoped>
  @mixin tongy($a) {
    content: '';
    width: 16px;
    display: inline-block;
    height: 3px;
    background: $a;
    margin-right: 8px;
    position: relative;
    bottom: 4px;
  }
  .tc-container {
    ul {
      list-style: none;
      display: flex;
      justify-content: flex-end;
      color: #15a983;
      cursor: pointer;
      li {
        margin-right: 30px;
        white-space: nowrap;
      }
      .is-active {
        border-bottom: 1px solid #ffc600;
        padding-bottom: 7px;
        position: relative;
        color: #fff;
        &::after {
          content: '';
          width: 0;
          height: 0;
          border-bottom: 5px solid #ffc600;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          position: absolute;
          bottom: 0px;
          left: 3px;
        }
      }
    }
    .tp-chart {
      width: 100%;
      height: 14vh;
    }
  }
</style>
